
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {switchMap, distinctUntilChanged, debounceTime, catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';





import { AppConfigService } from '../../shared/services/app.config.service';
import { LoginComponent } from '../../auth/login.component';


let AppConstant: any = {};
@Injectable()
export class CollateralService {

    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    getCollateralTypes() {
        return this.http.get(`credit/collateral-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateralDocumentTypes(id) {
        return this.http.get(`credit/collateral-document-type/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addCollateralDocumentType(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/collateral-document-type`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralTypeByApplication(id) {
        return this.http.get(`credit/collateral-type/loan-application/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateCollateralType(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/collateral-type/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getSubTypes() {
        return this.http.get(`credit/collateral-sub-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveSubType(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/collateral-sub-type`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateSubType(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/collateral-sub-type/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getValuerType() {
        return this.http.get(`credit/collateral-valuer-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getValuers() {
        return this.http.get(`credit/collateral-valuer`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralPerfectionStatus() {
        return this.http.get(`credit/collateral-perfection-status`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralUSageStatus() {
        return this.http.get(`credit/collateral-usage`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveValuer(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/collateral-valuer`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateValuer(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/collateral-valuer/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    // ------------------ LOANS COLLATERAL ------------------ \\
    
    // getLoanCollateral(id) {
    //     return this.http.get(`credit/customer-collateral/loan/${id}`) // redundant
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    getLoanApplicationCollateral(id) {
        return this.http.get(`credit/loan-application-collateral/loan-application/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getActiveCustomerCollateral(applicationId) {
        return this.http.get(`credit/customer-collateral/active/${applicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getActiveLoanCollateral(loanId,productTypeId) {
        return this.http.get(`credit/customer-collateral/loan/${loanId}/productTypeId/${productTypeId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCustomerCollateral(id,applicationId? : number) {
        return this.http.get(`credit/customer-collateral/customer/${id}/application/${applicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getProposedCustomerCollateral(applicationId,currencyId) {
        return this.http.get(`credit/collateral/application/${applicationId}/currencyId/${currencyId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getProposedCustomerCollateralByCustomerId(customerId, getAll = false) {
        return this.http.get(`credit/collateral/application/${customerId}/${getAll}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCustomerCollateralReport(searchParam) {
        return this.http.get(`credit/customer-collateral/searchParam/${searchParam}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCustomerCollateralRep(data) {
        return this.http.post(`credit/customer-collateral/customer`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getTempCustomerCollateral() {
        return this.http.get(`credit/temp-customer-collateral`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCustomerCollateralByCollaterId(collaterId) {
        return this.http.post(`credit/customer-collateral-by-collateralId`,collaterId).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getDocumentUploadList() {
        return this.http.get(`document/document-upload-list`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllValuationRequestWaitingForApproval() {
        return this.http.get(`valuation/get-valuation-waiting-for-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetAllValuationRequest(collateralId) {
        return this.http.get(`valuation/get-valuation-waiting-for-approval/${collateralId}/collateralId`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getTempItemPolicy() {
        return this.http.get(`credit/temp-item-policy`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getInsurancePoliciesWaitingForApproval() {
        return this.http.get(`credit/insurance-policy-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getTempItemPolicyList(collateralId) {
        return this.http.get(`credit/temp-item-policy/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getItemPolicyList(collateralId) {
        return this.http.get(`credit/item-policy/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCustomerCollateralInformationById(customercollateralId) {
        return this.http.get(`credit/collateral-information-view/${customercollateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),); 
    }

    // GetCollateralTypeByCollateral(collateralId, typeId) {
    //     console.log("the tracing collateral customer id =="+collateralId);
    //     return this.http.get(`credit/customer-collateral/${collateralId}/collateral/${typeId}/type`)
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    GetCollateralDetailsByCollateral(collateralId, typeId) {
        console.log("the tracing collateral customer id =="+collateralId);
        return this.http.get(`credit/customer-collateral/${collateralId}/collateral/${typeId}/type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralInfo(customercollateralId) {
        return this.http.get(`credit/collateral-information-view/${customercollateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralInformationByCollateralType(collateralId, typeId) {
        return this.http.get(`credit/customer-collateral/${collateralId}/collateral/${typeId}/type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getTempCollateralInformationByCollateralType(collateralId, typeId) {
        return this.http.get(`credit/temp-customer-collateral/type/collateral/${collateralId}/type/${typeId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
   
    mapCollateral(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/application-collateral/map`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    isMappedCollateral(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/application-collateral/mapped`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
        
    unmapCollateral(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/application-collateral/unmap`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteProposedCollateral(data) {
        return this.http.post(`credit/delete-proposed-collateral-coverage`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteDuplicatedCollateral(data) {
        return this.http.post(`credit/delete-duplicate-collateral`,data).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveCustomerCollateral(body) {

        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/customer-collateral`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

addNewPolicy(body) {

////console.log('body <<>>',body.value);

        let bodyObj = JSON.stringify(body.value);
        return this.http.post(`credit/add-insurance-policy`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateCustomerCollateral(body, collateralId) {
        // let bodyObj = JSON.stringify(body);
        return this.http.put(`credit/customer-collateral/${collateralId}`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    releaseCustomerCollateral(mappingId) {
        return this.http.get(`credit/customer-collateral/release/${mappingId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    assignCustomerCollateral(body) {
        return this.http.post(`credit/customer-collateral/assignment`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    // ------------------ TYPES ------------------ \\

    getValueBaseTypes(collateralType) {
        return this.http.get(`credit/collateral-value-base-type/${collateralType}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralSubTypes() {
        return this.http.get(`credit/collateral-sub-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getFrequencyTypes() {
        return this.http.get(`setups/frequency-types`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    // ------------------ PRODUCT MAPPING ------------------ \\

    getUnmappedCollateralToProduct(productId) {
        return this.http.get(`setups/product-collateral-type/unmapped/${productId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getMappedCollateralToProduct(productId) {
        return this.http.get(`setups/product-collateral-type/all/${productId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllMappedCollateralToProduct(productId) {
        return this.http.get(`setups/product-collateral-type/all/mapped/${productId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    mapColateralToProduct(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/product-collateral-type`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    removeColateralFromProduct(id) {
        return this.http.delete(`setups/product-collateral-type/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    // ------------------ DOCUMENT UPLOAD ------------------ \\
    getCollateralReleasedDocument(collateralId) {
        return this.http.get(`credit/collateral-document-release/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateralDocument(collateralId) {
        return this.http.get(`credit/collateral-document/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateralDocumentByCollaterCoe(collateralCode) {
        return this.http.get(`credit/collateral-document-by-collateralcode/${collateralCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getTempCollateralDocument(collateralId) {
        return this.http.get(`credit/temp-collateral-document/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralVisitationDetail(collateralCustomerId) {
        return this.http.get(`credit/loan-visitation/${collateralCustomerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getTempCollateralVisitationDetail(collateralCustomerId) {
        return this.http.get(`credit/temp-collateral-visitation/${collateralCustomerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getInsurancePolicies(collateralId) {
        return this.http.get(`credit/insurance-policies/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetInsurancePolicyByCollateralid(collateralId) {
        return this.http.get(`credit/insurance-policy/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getStockPrice() {
        return this.http.get(`credit/stock-price`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralVisitationFile(collateralVisitationID) {
        return this.http.get(`credit/loan-visitation-file/${collateralVisitationID}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getTempCollateralVisitationFile(collateralVisitationID) {
        return this.http.get(`credit/temp-collateral-visitation-file/${collateralVisitationID}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralGuaranteeFile(targetId) {
        return this.http.get(`credit/collateral-guarantee/${targetId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getCollateralHistory(collateralId) {
        return this.http.get(`credit/collateral-history/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralHistoryUsage(collateralId) {
        return this.http.get(`credit/collateral-history-usage/${collateralId}`)
        .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

 
    
    uploadFile(file: File, body: any) {
        let bodyObj = JSON.stringify(body);
        return new Promise((resolve, reject) => {

            let url = `credit/collateral-document`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();

            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.send(formData);
        });
    }

    uploadTempFile(file: File, body: any) {
        let bodyObj = JSON.stringify(body);
        return new Promise((resolve, reject) => {

            let url = `credit/temp-collateral-document`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();

            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.send(formData);
        });
    }
    customerCollateralRelease(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/customer-collateral/release-collateral`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    sendtoApprovalCollateralRelease(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/customer-collateral/complete-job-request-release-collateral`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    sendtoCollateralReleaseForApproval(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/customer-collateral/go-for-approval-release-collateral`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateralReleaseAwaitingJobRequest() {
        return this.http.get(`credit/customer-collateral/release-collateral-awaiting-job-request`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateralReleaseAwaitingApproval() {
        return this.http.get(`credit/customer-collateral/release-collateral-awaiting-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getSupportingDocumentByRelease(releaseId) {
        return this.http.get(`credit/customer-collateral/releaseId/${releaseId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getSupportingDocumentByDocumentId(documentId) {
        return this.http.get(`credit/customer-collateral/${documentId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    uploadAdditionalFile(file: File, body: any) {
        // let bodyObj = JSON.stringify(body);
        return new Promise((resolve, reject) => {

            let url = `credit/customer-collateral/supporting-document-upload`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();
            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.send(formData);
        });
    }


    getCollateralReleaseById(collateralId) {
        return this.http.get(`credit/customer-collateral/release-collateral-awaiting-job-request/collateralId/${collateralId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateralInformation(collateralCustomerId) {
        return this.http.get(`credit/customer-collateral/get-collateral-information/colateralcustomerId/${collateralCustomerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    postCollateralInformation(file: File, body: any) {
        let bodyObj = JSON.stringify(body);

        ////console.log('bodyObj >>>',bodyObj)

        return new Promise((resolve, reject) => {

            let url = `credit/customer-collateral`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();

            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            ////console.log('formData >>>',formData)

            xhr.send(formData);
        });
    }

   
    postJoinCollateralInformation(file: File, body: any) {
        let bodyObj = JSON.stringify(body);

        ////console.log('bodyObj >>>',bodyObj)

        return new Promise((resolve, reject) => {

            let url = `credit/customer-join-collateral`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();

            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            ////console.log('formData >>>',formData)

            xhr.send(formData);
        });
    }

  
    AddTempVisitationloadFile(file: File, body: any) {
        let bodyObj = JSON.stringify(body);

        ////console.log('body >>>',body)
        ////console.log('bodyObj >>>',bodyObj)

        return new Promise((resolve, reject) => {

            let url = `credit/temp-visitation-document` ;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();
            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);

                ////console.log(key, body[key]);
                
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            ////console.log('formData >>>',formData);

            xhr.send(formData);
        });
    }

    AddVisitationloadFile(file: File, body: any) {
        let bodyObj = JSON.stringify(body);

        ////console.log('body >>>',body)
        ////console.log('bodyObj >>>',bodyObj)

        return new Promise((resolve, reject) => {

            let url = `credit/visitation-document` ;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();
            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);

                ////console.log(key, body[key]);
                
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            ////console.log('formData >>>',formData);

            xhr.send(formData);
        });
    }

    // ------------------ APPROVALS ------------------ \\
    
    getPendingCollateralRelease() {
        return this.http.get(`credit/collateral-release/pending-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    approveCustomerCollateralRelease(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/customer-collateral/release-approval`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    approveCustomerCollateralCreation(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/temp/customer-collateral-approval`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    approveItemPolicyCreation(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`credit/insurance-policy-approval`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    // ------------------ SEARCH ------------------ \\
    
    search(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),distinctUntilChanged(),switchMap(term => this.searchEntries(term)),);
    }

    searchEntries(term) {
        return this.http.get(`credit/customer-collateral/search/?queryString=${term}`).pipe(
        // return this.http.get(`setup/staff/search/?queryString=${term}`)
        map((res: any) => res));
    }
    //------------------------------------------------------------



 
    getMappedCollateralToLoanApplication(customerId, loanApplicationId) {
        return this.http.get(`credit/mapped-collateral-application/customer/${customerId}/loanapplication/${loanApplicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getUnmappedCollateralToLoanApplication(customerId, loanApplicationId){
        return this.http.get(`credit/unmapped-collateral-application/customer/${customerId}/loanapplication/${loanApplicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    deleteCollateralApplicationMapped(body){
        return this.http.post(`credit/remove-mapped-collateral-application`,body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

     ///////////  GET LIENT AMOUNT FOR FIXED DEPOSIT 

    //  getLienAmountForFD(accountNo){
    //     return this.http.post(`credit/get-fixeddeposit-lien-amount`, accountNo).pipe(
    //         map((res: any) => res),
    //         catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    // }
    getLienAmountForFD(body){
        return this.http.post(`credit/get-fixeddeposit-lien-amount`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLienAmountForCASA(accountNumber){
        return this.http.get(`credit/get-casa-lien-amount/${accountNumber}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralSubTypesById(id) {
        return this.http.get(`credit/collateral-sub-type/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getFixedDepositAccountDetail(accountNumber) {
        return this.http.get(`credit/get-casa-balance/${accountNumber}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    proposeCollateral(data) {
        return this.http.post(`credit/propose-collateral`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    rejectCollateral(collateralCustomerId) {
        return this.http.get(`credit/reject-propose/collateral/${collateralCustomerId}/collateralCustomerId`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    getInsuranceType() {
    return this.http.get(`credit/insurance-type`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getInsuranceCompany() {
        return this.http.get(`credit/insurance-company`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    ////// Collateral Valuation ///////////////////////////////
    // Testing Collateral
    testCollateral(collateralId: number, typeId: number) {
        return this.http.get(`test/get-collateral-types/collateral/${collateralId}/type/${typeId}`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getValuationReports() {
        return this.http.get(`valuation/get-all-valuation-reports`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getValuationRequestTypes() {
        return this.http.get(`valuation/get-valuation-request-types`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addValuationReport(report) {
        let reportObj = JSON.stringify(report);
        return this.http.post(`valuation/add-valuation-report`, reportObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addCollateralValuation(valuation) {
        let valuationObj = JSON.stringify(valuation);
        return this.http.post(`valuation/add-collateral-valuation`, valuationObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addValuationPrerequisite(prerequisite) {
        let prerequisiteObj = JSON.stringify(prerequisite);
        return this.http.post(`valuation/add-valuation-prerequisite`, prerequisiteObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    editValuationPrerequisite(valuationPrerequisiteId, prerequisite) {
        let prerequisiteObj = JSON.stringify(prerequisite);
        return this.http.put(`valuation/edit-valuation-prerequisite/${valuationPrerequisiteId}/valuationPrerequisiteId`, prerequisiteObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteValuationPrerequisite(valuationPrerequisiteId: number) {
        return this.http.delete(`valuation/delete-valuation-prerequisite/${valuationPrerequisiteId}/valuationPrerequisiteId`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralValuation(collteralValuationId: number) {
        return this.http.get(`valuation/get-collateral-valuation/${collteralValuationId}/collteralValuationId`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    getValuationPrerequisite(valuationPrerequisiteId: number) {
        return this.http.get(`valuation/get-valuation-Prerequisite/${valuationPrerequisiteId}/valuationPrerequisiteId`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateValuationPrerequisiteStatus(valuationPrerequisiteId: number, prerequisite) {
        let prerequisiteObj = JSON.stringify(prerequisite);
        return this.http.put(`valuation/update-valuation-prerequisite-status/${valuationPrerequisiteId}/valuationPrerequisiteId`, prerequisiteObj).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralValuations(collateralId: number) {
        return this.http.get(`valuation/get-all-collateral-valuations/${collateralId}/collateralId`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getValuationPrerequisites(collateralValuationId: number) {
        return this.http.get(`valuation/get-all-valuation-prerequisites/${collateralValuationId}/collateralValuationId`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    goForApproval(collateral) {
        let collateralObj = JSON.stringify(collateral);
        return this.http.post(`valuation/go-for-approval`, collateralObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addInsurancePolicy(data) {
        return this.http.post(`credit/insurance-policy`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetinsuranceSearch(searchString) {
        return this.http.get(`credit/insurance-search/${searchString}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    checkInsurancePolicy(data) {
        return this.http.post(`credit/check-insurance-policy`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    insuranceRequestGoForApproval(data) {
        return this.http.post(`credit/insurance-request-go-for-approval`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addCollateralValuerInfo(data) {
        return this.http.post(`valuation/add-valuer`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    submitApproval(data) {
        return this.http.post(`valuation/submit-approval`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllCollateralValuerIformation() {
        return this.http.get(`valuation/get-valuer-info`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllCollateralValuerIformationById(id) {
        return this.http.get(`valuation/get-valuer-info/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetCollateralCoverage(collateralSubTypeId) {
        return this.http.get(`credit/collateral-coverage/${collateralSubTypeId}/collateralSubTypeId`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    AddCollateralCoverage(data) {
        return this.http.post(`credit/collateral-coverage`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    DeleteCollateralCoverage(collateralCoverageId) {
        return this.http.delete(`credit/delete-collateral-coverage/${collateralCoverageId}/collateralCoverageId`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    calculateCoverateOfCollateral(data) {
        return this.http.post(`credit/calculate-collateral-coverage`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addCollateralInsuranceRequest(data, id) {
        let dataObj = JSON.stringify(data);
        return this.http.post(`credit/insurance-policy-request/${id}`, dataObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateInsuranceRequest(data, id) {
        let dataObj = JSON.stringify(data);
        return this.http.put(`credit/update-insurance-policy-request/${id}`, dataObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

      getInsuranceRequests() {
        return this.http.get(`credit/get-insurance-requests`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
      }

      removeInsuranceRequest(insuranceRequestId) {
        return this.http.delete(`credit/delete-insurance-request/${insuranceRequestId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

        getLastComment(operationId, targetId) {
            return this.http.get(`credit/get-insurance-last-comment/${operationId}/${targetId}`).pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }

        savePolicy(body) {
            let bodyObj = JSON.stringify(body);
            return this.http.post(`credit/policy-insurance-doc`, bodyObj).pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }
    
        updateInsurancePolicy(id, body) {
            let bodyObj = JSON.stringify(body);
            return this.http.put(`credit/policy-insurance-doc/${id}`, bodyObj).pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }
        deleteInsurancePolicy(id) {
            return this.http.delete(`credit/policy-insurance-doc/${id}`).pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }

        getLienByApplicationDetailId(applicationDetailId) {
            return this.http.get(`credit/lien-applicationDetailId/${applicationDetailId}`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        placeLienOnInvestment(body) {
            let bodyObj = JSON.stringify(body);
            return this.http.post(`credit/lien`, bodyObj)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        deleteLienOnInvestment(id) {
            return this.http.delete(`credit/lien/${id}`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        saveCollateralSwapRequest(body) {
            let bodyObj = JSON.stringify(body);
            return this.http.post(`credit/collateral-swap`, bodyObj)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        getCollateralSwapRequests() {
            return this.http.get(`credit/collateral-swap`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        getCollateralSwapRequestsForApproval() {
            return this.http.get(`credit/collateral-swap-approval`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        getCollateralSwapRequest(id) {
            return this.http.get(`credit/collateral-swap/${id}`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        updateCollateralSwapRequest(body, id) {
            let bodyObj = JSON.stringify(body);
            return this.http.put(`credit/collateral-swap/${id}`, bodyObj)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        deleteCollateralSwapRequest(id) {
            return this.http.delete(`credit/collateral-swap/${id}`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        forwardForCollateralSwap(body) {
                console.log('forwarded =>');
                return this.http.post(`credit/collateral-swap/forward`, JSON.stringify(body))
                    .map((res: Response) => res.json())
                    .catch((error: any) => Observable
                        .throw(error.json().error || 'Server error'));
        }

        getCollateralMappingDetails(id) {
            return this.http.get(`credit/collateral-mapping/${id}`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        getAddedInsurance(CollateralId) {
            return this.http.get(`credit/get-insurance/${CollateralId}`)
                .map((res: Response) => res.json())
                .catch((error: any) => Observable
                    .throw(error.json().error || 'Server error'));
        }

        getProposedCustomerCollateralByCustomerIdLMS(customerId, getAll = false) {
            return this.http.get(`credit/collateral-lms/application/${customerId}/${getAll}`)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }

        proposeCollateralLMS(data) {
            return this.http.post(`credit/propose-collaterals-lms`, data)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }

        calculateCoverateOfCollateralLms(data) {
            return this.http.post(`credit/calculate-collateral-coverage-lms`, data)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => observableThrowError(error.error || 'Server error')),);
        }
}
//